import React from 'react';
import { Routes } from 'routes';
import { IRegionShort } from 'api/region/types';
import { ISubLink, ITabLink } from 'components/common/StickyTabsNav/types';
import { isMainLocale } from 'util/i18nFlags';

import { ReactComponent as SvgSnowFlake } from 'public/assets/icons/snowflake.svg';
import { ReactComponent as SvgMap } from 'public/assets/icons/map.svg';
import { CommonKeyTranslationFuncProps } from 'i18n/useOTSTranslation';
import { hasWeSkiIntegration } from 'components/common/PlanYourTrip/WeSki/resolver';

export enum CurrentTab {
  SNOW = 'snow_reports',
  TRIP_PLANNING = 'trip_planning',
}

export enum CurrentLink {
  SNOW_REPORT = 'snow_reports',
  WEATHER = 'weather',
  CAMS = 'cams',
  FHR = 'first_hand',
  OVERVIEW = 'overview',
  OPEN_RESORTS = 'open_resorts',
  PROJECTED_CLOSING = 'projected_closing',
  PROJECTED_OPENINGS = 'projected_openings',
  REVIEWS = 'reviews',
  TRAILMAP = 'trailmap',
  SNOWPLANNER = 'snowplanner',
  LIFTACCESS = 'liftaccess',
  LODGING = 'lodging',
  LIFT_TICKETS = 'lift_tickets',
}

export const tabs: (region: IRegionShort) => Array<ITabLink<CurrentTab>> = (region: IRegionShort) => (
  isMainLocale()
    ? [{
      render: (t) => (
        <>
          <SvgSnowFlake height={20} />
          {t('nav.tab.snow')}
        </>
      ),
      uuid: CurrentTab.SNOW,
      href: Routes.regionSnowReport(region),
    },
    {
      render: (t) => (
        <>
          <SvgMap height={27} />
          {t('nav.tab.tripPlanning')}
        </>
      ),
      uuid: CurrentTab.TRIP_PLANNING,
      href: Routes.regionTripPlanningOverview(region),
    }]
    : [{
      render: (t) => (
        <>
          <SvgSnowFlake height={20} />
          {t('nav.tab.snow')}
        </>
      ),
      uuid: CurrentTab.SNOW,
      href: Routes.regionSnowReport(region),
    }]
);

export const linksSnow: (
  region: IRegionShort,
  t: CommonKeyTranslationFuncProps
) => Array<ISubLink<CurrentLink>> = (region: IRegionShort, t) => [
  {
    title: t('nav.tab.snowReport'),
    isExternal: false,
    href: Routes.regionSnowReport(region),
    uuid: CurrentLink.SNOW_REPORT,
  },
  {
    title: t('nav.tab.cams'),
    isExternal: false,
    href: Routes.regionCams(region),
    uuid: CurrentLink.CAMS,
  },
];

export const linksPlan: (
  region: IRegionShort,
  t: CommonKeyTranslationFuncProps
) => Array<ISubLink<CurrentLink>> = (region: IRegionShort, t) => [
  {
    title: t('nav.tab.overview'),
    isExternal: false,
    href: Routes.regionTripPlanningOverview(region),
    uuid: CurrentLink.OVERVIEW,
  },
  {
    title: t('nav.tab.openResorts'),
    isExternal: false,
    href: Routes.regionOpenResorts(region),
    uuid: CurrentLink.OPEN_RESORTS,
  },
  {
    title: t('nav.tab.OpenDates'),
    isExternal: false,
    href: Routes.regionProjectedOpenings(region),
    uuid: CurrentLink.PROJECTED_OPENINGS,
  },
  {
    title: t('nav.tab.ClosingDates'),
    isExternal: false,
    href: Routes.regionProjectedClosing(region),
    uuid: CurrentLink.PROJECTED_CLOSING,
  },
  {
    title: hasWeSkiIntegration({ regionId: region.uuid }) ? 'Ski Holidays' : t('nav.tab.lodging'),
    isExternal: false,
    href: Routes.regionLodging(region),
    uuid: CurrentLink.LODGING,
  },
  {
    title: t('nav.tab.liftTickets'),
    isExternal: false,
    href: Routes.regionLiftTickets(region),
    uuid: CurrentLink.LIFT_TICKETS,
  },
];
